<template>
  <div class="markdown-body" v-html="html"></div>
</template>

<script>
// Markdown 渲染 wrapper —— 接收 frontmatter-markdown-loader (Mode.HTML)
// 产出的 HTML 字符串,用 v-html 渲染。
// 单作者博客内容可信,XSS 风险可忽略;若未来开放不可信内容需引入 DOMPurify。
export default {
  name: 'MarkdownView',
  props: {
    html: {
      type: String,
      default: ''
    }
  }
}
</script>
